<template>
  <o-view>
    <o-view>
      <o-nav-bar title="License Plates" :has-back-button="true" />
      <o-block-list title="My License Plates">
        <o-license-plate label="Volvo" plateNumber="1-STX-301" />
        <o-license-plate label="Audi" plateNumber="1-BQQ-210" />
      </o-block-list>
    </o-view>
    <o-pay-button label="Save" @click="goBack" />
  </o-view>
</template>

<script>
import OLicensePlate from '@/components/OLicensePlate.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  components: {
    OLicensePlate,
    OPayButton
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
